/**
 * Which product surfaces this build shows.
 *
 * The pivot (operator, 2026-09-22): Prii is "Find your Friends at Festivals".
 * Maps, Sets and Find are the product; the social layer — open-ended chat and
 * the match queue — is deferred, not deleted. It stays in the codebase and in
 * the longer-term vision; it is simply not what a new user meets this weekend.
 *
 * Every hidden surface is hidden HERE, in one place, so turning it back on is
 * one boolean rather than an archaeology exercise. The routes themselves stay
 * mounted where removing them would strand a user mid-flow (see App.js) — a
 * hidden surface redirects, it does not 404.
 */
export const SURFACES = {
  /** The Chats tab, the chat list, DMs, and the group message thread. */
  chats: false,
  /** "Match me" on the RSVP join flow — the match queue. */
  matchMe: false,
  /** The Sets page (set times / lineup by day and stage). */
  sets: true,
};

/**
 * Groups are NOT a social feature here — Find is group-scoped, so a group is
 * how you find your friends. With chat off, a group's home is its info page
 * (members, invite, lineup), not its message thread.
 */
export function groupHomePath(groupId) {
  return SURFACES.chats ? `/groups/${groupId}` : `/groups/${groupId}/info`;
}

/** Where "your groups" lives: the chat list when chat is on, the groups index when it is not. */
export const GROUPS_INDEX_PATH = SURFACES.chats ? '/chats' : '/groups';
